// src/layouts/CustomAppBar.tsx - VERSIÓN MEJORADA (OPCIONAL)
import React from 'react';
import { AppBar, TitlePortal, useSidebarState } from 'react-admin';
import { Box, IconButton, Typography, useMediaQuery, useTheme, Chip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Hotel as HotelIcon } from '@mui/icons-material';
import { MyUserMenu } from './MyUserMenu';

export const CustomAppBar: React.FC = () => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [open, setOpen] = useSidebarState();
    
    const userName = localStorage.getItem('username') || 'Guest';

    return (
        <AppBar
            userMenu={<MyUserMenu />} 
            elevation={0}
            sx={{
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary,
                height: '64px',
                minHeight: '64px',
                position: isMobile ? 'fixed' : 'static',
                top: isMobile ? 0 : 'auto',
                left: isMobile ? 0 : 'auto',
                right: isMobile ? 0 : 'auto',
                zIndex: isMobile ? 1200 : 'auto',
                border: 'none',
                boxShadow: 'none',
                
                '& .MuiToolbar-root': {
                    padding: { xs: '0 8px', sm: '0 16px' },
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '64px',
                    minHeight: '64px !important',
                    backgroundColor: theme.palette.background.default,
                    border: 'none',
                },
            }}
        >
            {/* Parte izquierda */}
            {!isMobile && (
                <Box sx={{ 
                    flex: 1, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'flex-start',
                    minWidth: 0,
                }}>
                    <IconButton
                        color="inherit"
                        aria-label={userName}
                        onClick={() => setOpen(!open)}
                        edge="start"
                        sx={{ 
                            mr: 2, 
                            display: { md: 'none' },
                            width: '40px',
                            height: '40px',
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                   
                    <TitlePortal sx={{ fontWeight: 700, fontSize: '1.05rem' }} />
                    
                    
                </Box>
            )}

            {/* Parte central */}
            {!isMobile && (
                <Box sx={{ 
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2,
                    pointerEvents: 'none',
                    maxWidth: isMobile ? '60%' : '80%',
                    '& > *': {
                        pointerEvents: 'auto'
                    }
                }}>
                    {isLargeScreen && (
                        <Typography
                            variant="h6"
                            component="span"
                            sx={{
                                color: '#00697A60',
                                fontWeight: 900,
                                whiteSpace: 'nowrap',
                                fontSize: '1.35rem',
                                '@media (max-width: 1200px)': {
                                    fontSize: '1.1rem',
                                },
                            }}
                        >
                            Roommatik Locker Management
                        </Typography>
                    )}
                </Box>
            )}
        </AppBar>
    );
};

export default CustomAppBar;